/** Energy — electricity report /energy/electricity-report (electricityReport.vue, TableFocusMode.vue) */
export default {
  electricityReport: {
    dashboardTitle: 'Electricity report',
    tabStatistics: 'Tenant totals',
    tabDetail: 'Tenant detail',
    exportLoading: 'Exporting...',
    exportReport: 'Export',
    filterStatPeriod: 'Period',
    phDateStart: 'Start',
    phDateEnd: 'End',
    filterTenant: 'Tenant',
    phTenant: 'Select tenant',
    filterTenantType: 'Tenant type',
    tenantType0: 'Tenant',
    tenantType1: 'Common area',
    tenantType2: 'Other',
    tenantType3: 'Solar',
    btnReset: 'Reset',
    btnSelectAll: 'Select all',
    btnDeselectAll: 'Clear selection',
    tooltipDeviceDetailStats: 'Device detail requires a single tenant (not “All”).',
    tooltipDeviceDetailSingle: 'Device detail requires one tenant to be selected.',
    deviceDetailSwitch: 'Device detail',
    todayElecBadge: 'Today kWh: {total} (S {peak}+P {top}+F {flat}+V {valley})',
    todayFeeBadge: 'Today bill: ¥{value}',
    todayElecRealtime: 'Today usage (live)',
    todayFeeRealtime: 'Today bill (live): ¥{value}',
    periodTotalElec: 'Selected-period total',
    periodHistoryElec: 'Historical usage',
    todayIncreaseRealtime: 'Today added (live)',
    periodTouComposition: 'Selected-period time-of-use',
    touPeakShort: 'Sharp',
    touTopShort: 'Peak',
    touFlatShort: 'Flat',
    touValleyShort: 'Valley',
    mainTotalElec: 'Total kWh',
    subPeak: 'Peak (sharp) kWh',
    subTop: 'Peak kWh',
    subFlat: 'Flat kWh',
    subValley: 'Valley kWh',
    mainTotalFee: 'Total (CNY)',
    subIndoorFee: 'Indoor (CNY)',
    subAcFee: 'HVAC (CNY)',
    tipNoFloatingTitle: 'Total excludes floating charges',
    tipNoFloatingShort: 'Excl. floating',
    loadingText: 'Loading...',
    chartTrendTitle: 'Usage trend',
    monitorTitle: 'Time-of-use kWh',
    legendTotalFee: 'Total bill',
    legendIndoorElec: 'Indoor kWh',
    legendAcElec: 'HVAC kWh',
    summaryTotalFee: 'Total bill',
    summaryIndoorElec: 'Indoor kWh',
    summaryAcElec: 'HVAC kWh',
    statPeak: 'Sharp peak',
    statTop: 'Peak',
    statFlat: 'Flat',
    statValley: 'Valley',
    seriesTotalFee: 'Total bill',
    seriesIndoorElec: 'Indoor kWh',
    seriesAcElec: 'HVAC kWh',
    seriesTodayCombo: 'Today kWh / bill',
    seriesPeakElec: 'Sharp peak kWh',
    seriesTopElec: 'Peak kWh',
    seriesFlatElec: 'Flat kWh',
    seriesValleyElec: 'Valley kWh',
    yAxisFee: 'Bill (CNY)',
    yAxisElec: 'kWh',
    todayShort: 'Today',
    tooltipTodayHeader: 'Today',
    tooltipElecLabel: 'kWh:',
    tooltipFeeLabel: 'Bill:',
    unitYuan: 'CNY',
    detailedData: 'Details',
    todayDataNote: 'Today is shown separately and is not included in the table total.',
    fullscreenView: 'Fullscreen',
    fullscreenTitle: 'Details — fullscreen',
    btnClose: 'Close',
    closeTitle: 'Close (ESC)',
    filterDevice: 'Filter device',
    phDeviceSearch: 'Search device name...',
    colDate: 'Date',
    colTotalFeeYuan: 'Total bill (CNY)',
    colIndoorFeeYuan: 'Indoor bill (CNY)',
    colAcFeeYuan: 'HVAC bill (CNY)',
    colTotalKwh: 'Total kWh',
    colSysTotalKwh: 'System total kWh',
    colIndoorKwh: 'Indoor kWh',
    colAcKwh: 'HVAC kWh',
    colAirSysKwh: 'HVAC system kWh',
    colPeakKwh: 'Sharp peak kWh',
    colTopKwh: 'Peak kWh',
    colFlatKwh: 'Flat kWh',
    colValleyKwh: 'Valley kWh',
    colFeeYuan: 'Bill (CNY)',
    colDevice: 'Device',
    colSettleWay: 'Settlement',
    colFee: 'Charge',
    colElecGroup: 'kWh',
    colGrandTotal: 'Total',
    colSpikeShort: 'Sharp',
    colPeakShort: 'Peak',
    colFlatShort: 'Flat',
    colValleyShort: 'Valley',
    colStartReading: 'Start read',
    colEndReading: 'End read',
    colTime: 'Time',
    colTotalElecShort: 'Total kWh',
    emptyNoData: 'No data',
    emptyNoDeviceDetail: 'No device-level rows',
    emptyNoMatch: 'No devices match',
    emptyTryOtherKeyword: 'Try another keyword',
    sectionDetailTitle: 'Tenant usage detail',
    sectionDeviceDetailTitle: 'Tenant — meter detail',
    colTenantId: 'Tenant ID',
    colTenantName: 'Tenant name',
    colMeter: 'Meter',
    colDetail: 'Detail',
    colStatistics: 'Summary',
    colElecFee: 'Bill (CNY)',
    colElecKwh: 'kWh',
    colPeakElec: 'Sharp peak kWh',
    colTopElec: 'Peak kWh',
    colFlatElec: 'Flat kWh',
    colValleyElec: 'Valley kWh',
    colPeakElecShort: 'Sharp peak',
    colTopElecShort: 'Peak',
    colFlatElecShort: 'Flat',
    colValleyElecShort: 'Valley',
    tenantAll: 'All',
    summaryTotal: 'Total',
    statTypeDay: 'Daily',
    statTypeMonth: 'Monthly',
    dateSpan100Days: '100 days',
    dateSpan1Year: '1 year',
    msgDateRangeLimit: 'Day view allows at most {span}.',
    msgDateLimit100: 'Day view allows at most 100 days.',
    msgTenantListFail: 'Failed to load tenants',
    msgPickPeriod: 'Please select a period',
    msgDeviceNeedTenant: 'Pick a tenant for device detail',
    msgPickTenant: 'Please select at least one tenant',
    msgFetchFail: 'Failed to load data',
    msgExportEmpty: 'Nothing to export',
    msgExportEmptyDevice: 'No device detail to export',
    msgExportOk: 'Export completed',
    msgExportFail: 'Export failed',
    msgExportRetry: 'Try again',
    msgDeviceAutoTenant: 'First tenant selected for device detail',
    msgNoTenantAvailable: 'No tenants available',
    errNoDeviceExport: 'No device detail rows to export',
    errNoTenantMeterExport: 'No tenant meter rows to export',
    expFilterTime: 'Period: {start} – {end}',
    expFilterTenant: 'Tenants: {tenant}',
    expFilterStatType: 'Granularity: {type}',
    expFilterDeviceDetail: 'Device detail',
    expJoinDetailLine: '{time} | {tenant} | {type}',
    expJoinDetailDevice: '{base} | {device}',
    settleWay0: 'Standard',
    settleWay1: 'Manual debit',
    settleWay2: 'System adjustment',
    settleWay3: 'Floating tariff',
    settleWay4: 'Shared allocation',
    settleWay5: 'Device debit',
    pickerYesterday: 'Yesterday',
    pickerThisWeek: 'This week',
    pickerLastWeek: 'Last week',
    pickerThisMonth: 'This month',
    pickerLastMonth: 'Last month',
    pickerLast3Months: 'Last 3 months',
    pickerLastYear: 'Last year',
    expColDate: 'Date',
    expColTotalFee: 'Bill (CNY)',
    expColIndoorFee: 'Indoor bill (CNY)',
    expColAcFee: 'HVAC bill (CNY)',
    expColTotalKwh: 'Total kWh',
    expColSysTotalKwh: 'System total kWh',
    expColIndoorKwh: 'Indoor kWh',
    expColAcKwh: 'HVAC kWh',
    expColAirSysKwh: 'HVAC system kWh',
    expColPeakKwh: 'Sharp peak kWh',
    expColTopKwh: 'Peak kWh',
    expColFlatKwh: 'Flat kWh',
    expColValleyKwh: 'Valley kWh',
    expColDevice: 'Device',
    expColSettleWay: 'Settlement',
    expColFee: 'Charge',
    expColElec: 'kWh',
    expColRegion: 'Region tag',
    expColTenantId: 'Tenant ID',
    expColTenantName: 'Tenant name',
    expColMeter: 'Meter',
    expSheetStat: 'tenant_totals',
    expSheetStatDevice: 'tenant_totals_meters',
    expSheetDetail: 'tenant_detail',
    expSheetDetailDevice: 'tenant_detail_meters',
    listSep: ', ',
    unitKwhDisplay: 'kWh'
  }
}
